import Icon from './Icon'

import { SortDirectionType } from '../utils/constants'

const TableColumnHeader = ({ title, sortable, datafield, sortColumnSignal, sortDirectionSignal }) => {

	const handleHeaderTableClick = (datafield) => {
		// if already sorted on this column then toggle sort direction
		if (datafield == sortColumnSignal.value) {
			//console.log("Toggling sort direction of field ".concat(datafield))
			sortDirectionSignal.value = sortDirectionSignal.value == SortDirectionType.DESCENDING ? SortDirectionType.ASCENDING : SortDirectionType.DESCENDING
			return
		}
		// update sort column - the computed functions will then run and render the sorted data
		sortColumnSignal.value = datafield
		//console.log("Updated sort column to ".concat(datafield))
	}

	// non-sortable columns do not have click handlers
	if (!sortable) {
		return (
			<th>{title}</th>
		)
	}
	// sortable column but isn't currently sorted on this column. Add click handler but no caret indicators
	else if (datafield != sortColumnSignal.value) {
		return (
			<th className="sortable-table-header" onClick={() => handleHeaderTableClick(datafield)}>{title}</th>
		)
	}
	// datafield matches sortColumn signal so we need to add a caret icon. sortDirection signal determines the direction
	else if (sortDirectionSignal.value == SortDirectionType.DESCENDING) {
		return (
			<th className="sortable-table-header" onClick={() => handleHeaderTableClick(datafield)}>{title}
				<Icon icon="caret-down" width="16" height="16"></Icon>
			</th>
		)
	}
	// else must be ascending
	return (
		<th className="sortable-table-header" onClick={() => handleHeaderTableClick(datafield)}>{title}
			<Icon icon="caret-up" width="16" height="16"></Icon>
		</th>
	)
}
export default TableColumnHeader